import { useRouter } from 'next/router';
import React, { useCallback } from 'react';
import OpenedChildMenu from './OpenedChildMenu';
import { trackNavClick } from 'lib/analytics';

const ChildMenu = (props) => {
  const router = useRouter();
  const { isHasChild, name, id, slug, openedChild, setOpenedChild, handleClose, childrenArray } = props;

  const handleRedirect = useCallback(
    (query) => {
      handleClose();
      trackNavClick({
        page_type: 'category',
        nav_item: query?.category || query?.name,
        location: 'header',
      });
      router.push({ pathname: '/category', query });
    },
    [handleClose, router]
  );

  const handleOnClickChild = () => {
    if (childrenArray?.length > 0) {
      const nextSlug = openedChild !== slug ? slug : '';
      setOpenedChild(nextSlug);
      trackNavClick({
        page_type: 'category',
        nav_item: nextSlug,
        location: 'header',
      });
      return;
    }

    handleRedirect({ category: slug, name });
  };

  return isHasChild ? (
    <div key={slug} className={`mobile-menu__menu-container ${openedChild === slug ? 'menu-opened' : ''}`}>
      <div className="mobile-menu__parent" onClick={handleOnClickChild}>
        <div>{name}</div>
        {childrenArray?.length > 0 && <i className="bi bi-chevron-down" />}
      </div>
      {childrenArray?.length > 0 && openedChild.includes(slug) && (
        <>
          {childrenArray.map((child) => {
            return (
              <OpenedChildMenu
                key={child.categorySlug}
                onClick={() => handleRedirect({ category: child.categorySlug, parent: slug })}
                name={child.categoryName}
              />
            );
          })}
          <div className="button-view-all" onClick={() => handleRedirect({ category: slug, name: name })}>
            View All
          </div>
        </>
      )}
    </div>
  ) : (
    <div key={id} className="mobile-menu__menu-container" onClick={() => handleRedirect({ provider: id, name: name })}>
      <div className="mobile-menu__parent">
        <span>{name}</span>
      </div>
    </div>
  );
};

export default ChildMenu;
